var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_16373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1673 16.5002H6.83398V3.50016C6.83398 3.4085 6.75898 3.3335 6.66732 3.3335H5.50065C5.40898 3.3335 5.33398 3.4085 5.33398 3.50016V17.8335C5.33398 17.9252 5.40898 18.0002 5.50065 18.0002H21.1673C21.259 18.0002 21.334 17.9252 21.334 17.8335V16.6668C21.334 16.5752 21.259 16.5002 21.1673 16.5002ZM8.66732 14.8335H9.83398C9.92565 14.8335 10.0007 14.7585 10.0007 14.6668V11.6668C10.0007 11.5752 9.92565 11.5002 9.83398 11.5002H8.66732C8.57565 11.5002 8.50065 11.5752 8.50065 11.6668V14.6668C8.50065 14.7585 8.57565 14.8335 8.66732 14.8335ZM11.834 14.8335H13.0007C13.0923 14.8335 13.1673 14.7585 13.1673 14.6668V8.00016C13.1673 7.9085 13.0923 7.8335 13.0007 7.8335H11.834C11.7423 7.8335 11.6673 7.9085 11.6673 8.00016V14.6668C11.6673 14.7585 11.7423 14.8335 11.834 14.8335ZM15.0007 14.8335H16.1673C16.259 14.8335 16.334 14.7585 16.334 14.6668V9.62516C16.334 9.5335 16.259 9.4585 16.1673 9.4585H15.0007C14.909 9.4585 14.834 9.5335 14.834 9.62516V14.6668C14.834 14.7585 14.909 14.8335 15.0007 14.8335ZM18.1673 14.8335H19.334C19.4257 14.8335 19.5007 14.7585 19.5007 14.6668V6.3335C19.5007 6.24183 19.4257 6.16683 19.334 6.16683H18.1673C18.0757 6.16683 18.0007 6.24183 18.0007 6.3335V14.6668C18.0007 14.7585 18.0757 14.8335 18.1673 14.8335Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_16373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c6209f9923abeff69fc5eb67a505ec60.svg";
export { ForwardRef as ReactComponent };